/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createRevenueKpiFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type RevenueKpi } from '../../../models/index.js';
// @ts-ignore
import { TrendRequestBuilderRequestsMetadata, type TrendRequestBuilder } from './trend/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/revenue
 */
export interface RevenueRequestBuilder extends BaseRequestBuilder<RevenueRequestBuilder> {
    /**
     * The trend property
     */
    get trend(): TrendRequestBuilder;
    /**
     * Sums the order totals of every active order the organization took in the period. Both bounds are inclusive and are compared against the order's own date as a full timestamp, so an end date sent without a time stops at midnight — send 2026-03-31T23:59:59Z to take in the whole of the last day. Order status is not considered, so an order counts whatever stage it has reached; only orders marked inactive drop out. A period with no orders is a success reporting zero, never a 404, and the dates you sent come back on the response so a cached chart can be matched to its window.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RevenueKpi>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<RevenueRequestBuilderGetQueryParameters> | undefined) : Promise<RevenueKpi | undefined>;
    /**
     * Sums the order totals of every active order the organization took in the period. Both bounds are inclusive and are compared against the order's own date as a full timestamp, so an end date sent without a time stops at midnight — send 2026-03-31T23:59:59Z to take in the whole of the last day. Order status is not considered, so an order counts whatever stage it has reached; only orders marked inactive drop out. A period with no orders is a success reporting zero, never a 404, and the dates you sent come back on the response so a cached chart can be matched to its window.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<RevenueRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Sums the order totals of every active order the organization took in the period. Both bounds are inclusive and are compared against the order's own date as a full timestamp, so an end date sent without a time stops at midnight — send 2026-03-31T23:59:59Z to take in the whole of the last day. Order status is not considered, so an order counts whatever stage it has reached; only orders marked inactive drop out. A period with no orders is a success reporting zero, never a 404, and the dates you sent come back on the response so a cached chart can be matched to its window.
 */
export interface RevenueRequestBuilderGetQueryParameters {
    /**
     * End of the period, inclusive. Compared against the order date as a full timestamp, so adate with no time stops at midnight; it must not be earlier than the start date.
     */
    endDate?: Date;
    /**
     * Start of the period, inclusive. Compared against the order date as a full timestamp.
     */
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const RevenueRequestBuilderUriTemplate = "{+baseurl}/api/analytics/revenue?endDate={endDate}&startDate={startDate}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const RevenueRequestBuilderNavigationMetadata: Record<Exclude<keyof RevenueRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    trend: {
        requestsMetadata: TrendRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const RevenueRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: RevenueRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRevenueKpiFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
